import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { getEnergyPrice, getCarbonMarketPrice } from '../../../engine/oracleAdapter';

export function OraclePanel() {
  const [country, setCountry] = useState<'EU'|'DE'|'FR'|'ES'|'IT'|'HU'|'NL'|'US'|'UK'>('EU');
  const [intervalSec, setIntervalSec] = useState(15);
  const [energy, setEnergy] = useState<number>(0);
  const [carbon, setCarbon] = useState<number>(0);

  useEffect(() => {
    let mounted = true;
    const tick = async () => {
      const [e, c] = await Promise.all([getEnergyPrice(country), getCarbonMarketPrice(country)]);
      if (mounted) { setEnergy(e); setCarbon(c); }
    };
    void tick();
    const id = setInterval(tick, Math.max(5, Math.min(120, intervalSec)) * 1000);
    return () => { mounted = false; clearInterval(id); };
  }, [country, intervalSec]);

  return (
    <div className="space-y-3">
      <div className="font-orbitron text-evat-gold">Oracle Prices</div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 text-sm">
        <label className="flex items-center gap-2">Country
          <select value={country} onChange={(e) => setCountry(e.target.value as any)} className="bg-black border border-evat-neon text-evat-neon px-2 py-1 rounded">
            {['EU','DE','FR','ES','IT','HU','NL','US','UK'].map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        </label>
        <label className="flex items-center gap-2">Refresh (s)
          <input type="number" min={5} max={120} value={intervalSec} onChange={(e) => setIntervalSec(Number(e.target.value))} className="bg-black border border-evat-neon text-evat-neon px-2 py-1 rounded w-24" />
        </label>
        <div className="flex items-center gap-4">
          <div>Energy: <span className="text-evat-gold">€{energy.toFixed(3)}/kWh</span></div>
          <div>Carbon: <span className="text-evat-neon">€{carbon}/t</span></div>
        </div>
      </div>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="text-xs text-neutral-500">Mock values with random drift, cached in /data/oracle.json</motion.div>
    </div>
  );
}

export default OraclePanel;



















